import React from 'react';

import { ChevronLeft } from 'lucide-react';

// Back button for nested pages inside settings-style modals (rail icon-button spec:
// 36px circle, 0.5px white border, white hover). Pairs with the matching close button
// passed to Modal via closeButtonClassName.
const SettingsBackButton = ({ onClick }) => {
  return (
    <button
      type="button"
      data-app-region="none"
      onClick={onClick}
      aria-label="Back"
      className="absolute top-5 left-5 z-(--stack-modal-close) flex size-9 cursor-pointer items-center justify-center rounded-full border-[0.5px] border-white bg-gray-50 text-black shadow-[0px_4px_4px_rgba(0,0,0,0.02)] hover:bg-white dark:border-white/10 dark:bg-neutral-900 dark:hover:bg-neutral-800"
    >
      {/* 1px left nudge: the chevron's open side is right-heavy, so geometric center reads shifted right */}
      <ChevronLeft className="pointer-events-none size-5.5 -translate-x-px" strokeWidth={1.75} absoluteStrokeWidth />
    </button>
  );
};

export default SettingsBackButton;
